import { useEffect, useRef, useState } from "react";
import { Bell, Package, Check, X, Sunrise } from "lucide-react";
import api from "../lib/api";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const loadCount = () => api.get("/notifications/unread_count").then(({ data }) => setCount(data.count)).catch(() => {});
  const loadItems = () => api.get("/notifications").then(({ data }) => setItems(data)).catch(() => {});

  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 15000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) loadItems();
  };

  const markAll = async () => {
    await api.put("/notifications/read_all");
    loadCount(); loadItems();
  };

  const removeOne = async (e, id) => {
    e.stopPropagation();
    await api.delete(`/notifications/${id}`);
    loadCount(); loadItems();
  };

  const markOne = async (id, lu) => {
    if (!lu) { await api.put(`/notifications/${id}/read`); loadCount(); loadItems(); }
  };

  const fmt = (s) => new Date(s).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} className="relative w-10 h-10 rounded-lg flex items-center justify-center hover:bg-[var(--tm-surface-2)] transition-colors" data-testid="notif-bell" style={{ border: "1px solid var(--tm-border)" }}>
        <Bell size={18} style={{ color: count > 0 ? "var(--tm-gold)" : "var(--tm-muted)" }} />
        {count > 0 && (
          <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center text-black" style={{ background: "#FF9800" }} data-testid="notif-count">
            {count}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 tm-card tm-fade z-50 overflow-hidden" data-testid="notif-dropdown" style={{ boxShadow: "0 20px 50px rgba(0,0,0,.6)" }}>
          <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: "1px solid var(--tm-border)" }}>
            <span className="font-display text-lg">Alertes</span>
            {items.some((i) => !i.lu) && (
              <button onClick={markAll} className="text-xs flex items-center gap-1 text-[var(--tm-gold)] hover:underline" data-testid="notif-mark-all"><Check size={13} /> Tout lire</button>
            )}
          </div>
          <div className="max-h-80 overflow-y-auto">
            {items.length === 0 ? (
              <p className="text-sm text-[var(--tm-muted)] text-center py-10">Aucune alerte pour l'instant.</p>
            ) : (
              items.map((n) => {
                const isRecap = n.type === "recap_quotidien";
                const Icon = isRecap ? Sunrise : Package;
                const tint = isRecap ? "var(--tm-gold)" : "#FF9800";
                return (
                <div key={n.id} onClick={() => markOne(n.id, n.lu)} className="flex gap-3 px-4 py-3 cursor-pointer hover:bg-[var(--tm-surface-2)] transition-colors" style={{ borderBottom: "1px solid #1c1c1c", background: n.lu ? "transparent" : "rgba(212,175,55,.05)" }} data-testid={`notif-item-${n.id}`}>
                  <span className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0" style={{ background: isRecap ? "rgba(212,175,55,.15)" : "rgba(255,152,0,.15)" }}>
                    <Icon size={15} style={{ color: tint }} />
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-semibold truncate">{n.titre}</p>
                    <p className="text-xs text-[var(--tm-muted)] mt-0.5">{n.message}</p>
                    <p className="text-[10px] text-[var(--tm-muted)] mt-1">{fmt(n.created_at)}</p>
                  </div>
                  <button onClick={(e) => removeOne(e, n.id)} className="text-[var(--tm-muted)] hover:text-[#F44336] shrink-0"><X size={14} /></button>
                </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
}
